import { JobPositionStatistics, Loading, Typography } from "@cpj-ai/panel-npm-package";
import { useGetJobPositionReportQuery } from "@graphql/generated";
import { useParams } from "react-router-dom";

const StatisticsTabContent = () => {
  const { id } = useParams();
  const { data, loading } = useGetJobPositionReportQuery({
    variables: {
      id: id || "",
    },
  });

  const report = data?.organization?.jobPosition?.get?.report;

  return (
    <div className="flex flex-col gap-8 md:p-6">
      {loading ? (
        <Loading />
      ) : (
        <>
          <Typography className="text-xl">Report</Typography>
          <JobPositionStatistics report={report} />
        </>
      )}
    </div>
  );
};

export default StatisticsTabContent;
